/*
 * OutOfDeliveryModal Messages
 *
 * This contains all the text for the OutOfDeliveryModal component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.OutOfDeliveryModal.title',
    defaultMessage: 'Lamentablemente no entrega a la dirección seleccionada',
  },
  subtitle: {
    id: 'app.components.OutOfDeliveryModal.subtitle',
    defaultMessage:
      'Podés seleccionar otra dirección o buscar resultados para esta dirección',
  },
  searchForAddressButton: {
    id: 'app.components.OutOfDeliveryModal.searchForAddressButton',
    defaultMessage: 'Buscar para esta dirección',
  },
  changeAddressButton: {
    id: 'app.components.OutOfDeliveryModal.changeAddressButton',
    defaultMessage: 'Cambiar dirección',
  },
});
